import React from 'react';
import closeImage from '../../../../images/icon/icon-close.svg';
import uro2024SquareImage from '../../../../images/get-started/packs/euro2024-square.jpg';
import uro2024BannerImage from '../../../../images/get-started/packs/euro2024-banner.jpg';

interface EuroModalProps {
}

const EuroModal: React.FC<EuroModalProps> = () => {
    return (
<>  
        <div className="modal-wrapper addEuro-modal">
            <div className="modal-dialog">
              <div className="modal-content-wrapper">
                <div className="close-wrap">
                    <div className="close-btn"><button className="close-modal">Close <img src={closeImage} alt="" /></button></div>
                </div>
                
                <div className="add-plan-wrapper">
                    <h2>Don’t forget UEFA EURO 2024™<br />Get the special combo offer</h2>
                    <h4>Save $400 for EURO Event Pass with this combo</h4>
    
                    <div className="item">
                        <img src={uro2024SquareImage} className="desktop" alt="" />
                        <img src={uro2024BannerImage}  className="mobile" alt="" />
                        <div className="content">
                            <div className="top">
                                <h3>Euro 2024 </h3>
                                <p>Watch LIVE matches, on-demand replays and highlights of UEFA EURO 2024™ . On-demand replays will be available within 24 hours after each match and valid until August 14, 2024.</p>
                            </div>
                            
                            <div className="bottom">
                                <div className="commitment">
                                    <div className="price">+$580 <span style={{ textDecoration: 'line-through' }}>($980)</span></div>
                                    <small><span id="selected-plan-title"></span>  will be subscribed automatically for 12 months at <span id="selected-plan-total"></span> beginning on the next day of the Pack End Date for this pack.</small>
                                </div>
                                <div className="cta-controls">
                                    <button className="btn primary addplan" id="addEuro-btn" >Add Pack</button>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div className="no-thanks">
                        <button className="btn secondary noThanks" ott-campaign="" id="euro-noThanks">No, Thanks</button>
                    </div>
                </div>
    
              </div>
        
            </div>
        
        </div>

        <div className="modal-wrapper addEuro-modal">
            <div className="modal-dialog">
              <div className="modal-content-wrapper">
                <div className="close-wrap">
                    <div className="close-btn"><button className="close-modal">關閉 <img src={closeImage} alt="" /></button></div>
                </div>
                
                <div className="add-plan-wrapper">
                    <h2>仲有歐洲國家盃！<br />即以特別組合優惠訂購</h2>
                    <h4>幫你慳 $400 訂購歐洲國家盃</h4>
    
                    <div className="item">
                        <img src={uro2024SquareImage} className="desktop" alt="" />
                        <img src={uro2024BannerImage}  className="mobile" alt="" />
                        <div className="content">
                            <div className="top">
                                <h3>Euro 2024 </h3>
                                <p>收看歐洲國家盃 2024賽事直播、點播重溫及精華片段。點播重溫於每個賽事完畢後24小時內上架, 自由點播至 2024年8月14日。</p>
                            </div>
                            
                            <div className="bottom">
                                <div className="commitment">
                                    <div className="price">+$580 <span style={{ textDecoration: 'line-through' }}>($980)</span></div>
                                    <small>此組合完結日之翌日將以<span id="selected-plan-total"></span>自動續訂<span id="selected-plan-title"></span>12個月。</small>
                                </div>
                                <div className="cta-controls">
                                    <button className="btn primary addplan" id="addEuro-btn" >加購此組合</button>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div className="no-thanks">
                        <button className="btn secondary noThanks" ott-campaign="" id="euro-noThanks">不需要，謝謝</button>
                    </div>
                </div>
    
              </div>
        
            </div>
        
        </div>
</>
    );
}
export default EuroModal;